export default __webpack_public_path__ + "static/media/11.43af1742.jpeg";